import { Expose } from 'class-transformer';
import { TemplateType } from '../enums/template.enum';
import { ITemplates as ITemplate } from '../interfaces/template.interface';
import { BaseFixedModel } from './base.model';

export class TemplateModel extends BaseFixedModel implements ITemplate {
  @Expose()
  html!: string;

  @Expose()
  css?: string;

  @Expose()
  name!: string;

  @Expose()
  code!: string;

  @Expose()
  type!: TemplateType;

  @Expose()
  isDefault!: boolean;

  @Expose()
  businessUnitId!: number;
}
